import React from 'react';
import {getCookie} from 'typescript-cookie';
import {Navigate, useLocation} from 'react-router-dom';

type Props = {
    allowed: string[];
    children: React.ReactElement;
};

const RequiredRole: React.FC<Props> = ({allowed, children}) => {
    const role = getCookie('roleType') || '';
    const location = useLocation();

    if (!role || !allowed.map(a => a).includes(role)) {
        return <Navigate to="/home" replace state={{from: location}}/>;
    }
    return children;
};

export default RequiredRole;